import { useRef, useEffect, useState } from "react";

/**
 * Hook pour détecter si l'utilisateur est sur macOS
 */
export const useMacOSDetection = (): boolean => {
  const [isMacOS, setIsMacOS] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsMacOS(userAgent.includes("mac"));
  }, []);

  return isMacOS;
};

/**
 * Hook pour gérer les sélecteurs de date sur macOS
 */
export const useMacOSDatePicker = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const isMacOS = useMacOSDetection();

  const handleFocus = (e: any, onFocus?: any) => {
    if (isMacOS && inputRef.current) {
      // Sur macOS, on force l'affichage du sélecteur de date
      const input = inputRef.current as any;
      if (input.showPicker) {
        input.showPicker();
      }
    }

    // On propage au gestionnaire d'événement parent s'il existe
    if (onFocus) {
      onFocus(e);
    }
  };

  const handleMouseDown = (e: any, onMouseDown?: any) => {
    if (isMacOS && inputRef.current) {
      // Sur macOS, on empêche la fermeture du sélecteur en empêchant la propagation
      e.stopPropagation();
    }

    // On propage au gestionnaire d'événement parent s'il existe
    if (onMouseDown) {
      onMouseDown(e);
    }
  };

  return {
    inputRef,
    isMacOS,
    handleFocus,
    handleMouseDown
  };
};
